var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInformationSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33333 8V2V8Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 10.6667V12C11.3333 12.3536 11.1929 12.6928 10.9428 12.9428C10.6928 13.1929 10.3536 13.3333 10 13.3333H3.33333C2.97971 13.3333 2.64057 13.1929 2.39052 12.9428C2.14048 12.6928 2 12.3536 2 12V7.33333C2 6.97971 2.14048 6.64057 2.39052 6.39052C2.64057 6.14048 2.97971 6 3.33333 6H4.66667M6.66667 3.33333H6C5.64638 3.33333 5.30724 3.47381 5.05719 3.72386C4.80714 3.97391 4.66667 4.31304 4.66667 4.66667V9.33333C4.66667 9.68695 4.80714 10.0261 5.05719 10.2761C5.30724 10.5262 5.64638 10.6667 6 10.6667H12.6667C13.0203 10.6667 13.3594 10.5262 13.6095 10.2761C13.8595 10.0261 14 9.68695 14 9.33333V4.66667C14 4.31304 13.8595 3.97391 13.6095 3.72386C13.3594 3.47381 13.0203 3.33333 12.6667 3.33333H12M11.3333 6L9.33333 8M9.33333 8L7.33333 6M9.33333 8V2",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationSave);
export default __webpack_public_path__ + "static/media/information-save.a0e5e6b602c160b36ded841699aa92b4.svg";
export { ForwardRef as ReactComponent };